import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const SimilarCompanyFinder = ({ onFindSimilar }) => {
  const [profile, setProfile] = useState({
    industry: '',
    companySize: '',
    currentChallenge: '',
    priority: ''
  });

  const industryOptions = [
    { value: 'healthcare', label: 'Healthcare' },
    { value: 'financial', label: 'Financial Services' },
    { value: 'manufacturing', label: 'Manufacturing' },
    { value: 'retail', label: 'Retail' },
    { value: 'technology', label: 'Technology' },
    { value: 'education', label: 'Education' }
  ];

  const companySizeOptions = [
    { value: 'enterprise', label: 'Enterprise (1000+ employees)' },
    { value: 'midmarket', label: 'Mid-Market (100-999 employees)' },
    { value: 'smb', label: 'Small Business (<100 employees)' }
  ];

  const challengeOptions = [
    { value: 'vendor-lock', label: 'Vendor Lock-in Concerns' },
    { value: 'cost-optimization', label: 'Cost Optimization' },
    { value: 'performance', label: 'Performance Issues' },
    { value: 'scalability', label: 'Scalability Limitations' },
    { value: 'compliance', label: 'Compliance Requirements' },
    { value: 'innovation', label: 'Innovation Acceleration' }
  ];

  const priorityOptions = [
    { value: 'cost', label: 'Cost Reduction' },
    { value: 'independence', label: 'Vendor Independence' },
    { value: 'performance', label: 'Performance Improvement' },
    { value: 'agility', label: 'Business Agility' },
    { value: 'innovation', label: 'Innovation Capability' }
  ];

  const handleSubmit = (e) => {
    e?.preventDefault();
    onFindSimilar(profile);
  };

  const isFormValid = profile?.industry && profile?.companySize && profile?.currentChallenge && profile?.priority;

  return (
    <div className="bg-gradient-to-br from-brand-primary to-brand-primary/80 rounded-xl p-8 text-white">
      <div className="text-center mb-8">
        <Icon name="Search" size={48} className="mx-auto mb-4 text-brand-secondary" />
        <h2 className="text-2xl font-bold mb-3">
          Find Similar Company Success Stories
        </h2>
        <p className="text-white/90 max-w-2xl mx-auto">
          Tell us about your organization and current challenges. We'll match you with relevant 
          case studies from companies with similar profiles and transformation goals.
        </p>
      </div>
      <form onSubmit={handleSubmit} className="max-w-2xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Select
            label="Industry"
            options={industryOptions}
            value={profile?.industry}
            onChange={(value) => setProfile(prev => ({ ...prev, industry: value }))}
            className="text-text-primary"
          />

          <Select
            label="Company Size"
            options={companySizeOptions}
            value={profile?.companySize}
            onChange={(value) => setProfile(prev => ({ ...prev, companySize: value }))}
            className="text-text-primary"
          />

          <Select
            label="Current Challenge"
            options={challengeOptions}
            value={profile?.currentChallenge}
            onChange={(value) => setProfile(prev => ({ ...prev, currentChallenge: value }))}
            className="text-text-primary"
          />

          <Select
            label="Top Priority"
            options={priorityOptions}
            value={profile?.priority}
            onChange={(value) => setProfile(prev => ({ ...prev, priority: value }))}
            className="text-text-primary"
          />
        </div>

        <div className="mt-8 text-center">
          <Button
            type="submit"
            variant="secondary"
            size="lg"
            disabled={!isFormValid}
            iconName="ArrowRight"
            iconPosition="right"
            className="bg-white text-brand-primary hover:bg-gray-50"
          >
            Find Matching Case Studies
          </Button>
        </div>
      </form>
      {/* Benefits */}
      <div className="mt-8 pt-8 border-t border-white/20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
          <div>
            <Icon name="Target" size={24} className="mx-auto mb-2 text-brand-secondary" />
            <h4 className="font-semibold mb-1">Relevant Matches</h4>
            <p className="text-sm text-white/80">Industry and size-specific success stories</p>
          </div>
          <div>
            <Icon name="TrendingUp" size={24} className="mx-auto mb-2 text-brand-secondary" />
            <h4 className="font-semibold mb-1">Proven Results</h4>
            <p className="text-sm text-white/80">Quantified outcomes and ROI data</p>
          </div>
          <div>
            <Icon name="Users" size={24} className="mx-auto mb-2 text-brand-secondary" />
            <h4 className="font-semibold mb-1">Peer Insights</h4>
            <p className="text-sm text-white/80">Learn from similar organizations</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimilarCompanyFinder;